import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
} from "../../../basic/alert-dialog";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {Loader2} from "lucide-react";

interface RemoveTeamMemberAlertDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    memberName?: string;
    memberEmail?: string;
    memberLicenses?: string[];
    isRemoving?: boolean;
}

export function RemoveTeamMemberAlertDialog({
                                                open,
                                                onOpenChange,
                                                onConfirm,
                                                memberName,
                                                memberEmail,
                                                memberLicenses,
                                                isRemoving = false
                                            }: RemoveTeamMemberAlertDialogProps) {
    const {t} = useTranslationWithKeys();
    const hasLicenses = memberLicenses?.length > 0;
    const licenseText = hasLicenses
        ? t('admin.teams.teamManagement.removeMemberConfirmation.licenseWarning', {count: memberLicenses.length})
        : t('admin.teams.teamManagement.removeMemberConfirmation.noLicenseWarning');

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('admin.teams.teamManagement.removeMemberConfirmation.title')}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('admin.teams.teamManagement.removeMemberConfirmation.description', {
                            memberName,
                            memberEmail
                        })}{licenseText}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isRemoving}>
                        {t('common.action.cancel')}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                        onClick={onConfirm}
                        disabled={isRemoving}
                    >
                        {isRemoving ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin"/>
                                {t('common.removing')}
                            </>
                        ) : (
                            t('common.action.remove')
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}